{
    "components": {
        "buttons": {
            "default": {
                "add_to_cart": {
                    "label": "Add to cart"
                },
                "back": {
                    "label": "Back"
                },
                "cancel": {
                    "label": "Cancel"
                },
                "close": {
                    "label": "Close"
                },
                "confirm": {
                    "label": "Confirm"
                },
                "delete": {
                    "label": "Delete"
                },
                "edit": {
                    "label": "Edit"
                },
                "next": {
                    "label": "Next"
                },
                "previous": {
                    "label": "Previous"
                },
                "proceed_configuration": {
                    "label": "Proceed"
                },
                "save": {
                    "label": "Save"
                },
                "start_ordering": {
                    "label": "Start ordering"
                },
                "upload_photo": {
                    "label": "Upload photo"
                }
            },
            "previous_page": {
                "label": "Previous page"
            },
            "close": {
                "label": "Close"
            }
        },
        "discount_blocks": {
            "code_copied": "Code copied!"
        },
        "dropdown": {
            "menu_button": {
                "label": "Menu"
            }
        },
        "footer": {
            "newsletter": {
                "title": "Never miss an offer again",
                "subtitle": "Subscribe to our newsletter",
                "email_label": "Email address",
                "submit_button": "Send"
            }
        },
        "header": {
            "all_categories_line_1": "View all",
            "all_categories_line_2": "categories",
            "search_aria_label": "Search",
            "search_close_aria_label": "Close search",
            "search_placeholder": "What are you looking for?",
            "search_all_designs_title": "All designs for ‘{query}’",
            "search_all_designs_label": "designs",
            "search_suggestions_title": "Search suggestions",
            "search_products_title": "Products",
            "search_no_results_title": "No designs for ‘{query}’",
            "search_no_results_hint": "Check the spelling or try a broader word.",
            "search_scope_all_products": "All products",
            "search_scope_products": "Product…",
            "search_all_designs_title_scoped": "All designs for ‘{query}’ in {group}",
            "search_scope_reset": "Search ‘{query}’ in all products",
            "search_popular_on_title": "Popular on {name}",
            "search_categories_title": "Categories"
        },
        "layouts": {
            "login_status": {
                "cart": {
                    "label": "Cart"
                },
                "login": {
                    "label": "Sign In"
                },
                "welcome": {
                    "label": "Welcome,"
                },
                "welcome_back": {
                    "label": "Welcome back"
                }
            },
            "mobile_menu_button": {
                "label": "Menu"
            },
            "mobile_menu_drawer": {
                "back_to_categories": "Back to all categories",
                "close": "Close menu",
                "default_title": "Menu",
                "view_all": "View all {title}",
                "expand_submenu": "Expand submenu"
            }
        },
        "select_menus": {
            "default": {
                "placeholder": "Select option"
            }
        },
        "spinners": {
            "default": {
                "label": "Loading..."
            }
        },
        "header_slider": {
            "timer": {
                "days": "d",
                "hours": "h",
                "minutes": "m",
                "seconds": "s"
            }
        },
        "modals": {
            "register": {
                "has_account": "Already have an account?",
                "general_error": "Registration failed. Please try again."
            },
            "login": {
                "title": "Sign In"
            }
        },
        "wishlist": {
            "button": {
                "add_aria_label": "Add to wishlist",
                "remove_aria_label": "Remove from wishlist"
            },
            "header_button": {
                "aria_label": "Wishlist"
            },
            "toast": {
                "removed": "Removed from your wishlist",
                "undo": "Undo"
            },
            "guest_added": {
                "title": "Wishlist",
                "success": "Added to your wishlist",
                "login_prompt": "{login} or {register} to keep your wishlist on all your devices and share it.",
                "login": "Log in",
                "register": "create an account",
                "continue_shopping": "Continue shopping",
                "view_wishlist": "View wishlist"
            }
        },
        "related_products": {
            "title": "Choose your design",
            "show_all": "View all",
            "show_less": "Show less",
            "section_title": "Discover more from this collection"
        },
        "same_kind_products": {
            "title": "You'll probably like these too"
        },
        "same_print_products": {
            "title": "This print on more products"
        },
        "pdp_steps": {
            "step_label": "Step {number}"
        },
        "pdp_review_videos": {
            "play_label": "Play video review from {name}"
        },
        "video": {
            "play_label": "Play video"
        },
        "slider": {
            "go_to_item": "Go to item {index} of {total}"
        },
        "lightbox": {
            "counter": "{current} of {total}"
        }
    },
    "general": {
        "delivery_options": {
            "day_after_tomorrow": {
                "label": "Order today, delivered <b>day after tomorrow</b>!"
            },
            "delivered_in_days": {
                "label": "Delivered in <b>{days} days</b>"
            },
            "delivered_in_business_days": {
                "label": "Ordered today, delivered in {days} business day! | Ordered today, delivered in {days} business days!"
            },
            "today_delivery": {
                "label": "Order today, delivered <b>today</b>!"
            },
            "tomorrow_delivery": {
                "label": "Order today, delivered <b>tomorrow</b>!"
            }
        },
        "password": {
            "confirmation": {
                "label": "Confirm password"
            },
            "confirmation_new": {
                "label": "Confirm new password"
            },
            "current": {
                "label": "Current password"
            },
            "label": "Password",
            "mismatch": "The passwords do not match. Please check the fields again.",
            "new": {
                "label": "New password"
            },
            "requirements": "Use 3 different character types in the password. Possible characters: lowercase letters, uppercase letters, numbers, and special characters."
        },
        "price_tables": {
            "entries": {
                "amount_label": "1 piece | {count} pieces",
                "all_sizes": "All sizes"
            },
            "title": {
                "amount": "Amount",
                "size": "Size"
            }
        },
        "prices": {
            "excl_discount": {
                "label": "Price excl. discount"
            },
            "for": {
                "label": "For"
            },
            "from": {
                "label": "From"
            },
            "starting_from": {
                "label": "From"
            },
            "title": "Prices",
            "total": {
                "label": "Total"
            }
        },
        "product_description": {
            "title": "Product description"
        },
        "question_and_answers": {
            "no_data": {
                "primary_text": "There are no questions and answers."
            },
            "title": "Questions and answers",
            "subtitle": "What customers ask most often."
        },
        "reviews": {
            "buyer": "Buyer",
            "customer_images": "Customer images",
            "view_more_images": "View more",
            "filter_all_stars": "Show all",
            "filter_label": "Filter",
            "filter_stars": "1 star | {count} stars",
            "highest_rated_title": "Customer reviews",
            "no_reviews_title": "No written reviews yet",
            "no_reviews_description": "There is 1 rating of {rating} stars. | There are {votes} ratings with an average of {rating} stars.",
            "image_alt": "Review image",
            "no_results_for_filter": "There are no reviews for this filter.",
            "read_full_review": "Read full review",
            "review_amount": "{count} rating | {count} ratings",
            "review_count": "{votes} Ratings of which {reviewCount} written",
            "show_all_reviews": "Show all {count} customer reviews",
            "show_less": "Show less",
            "show_original": "This is a translation, show original",
            "show_star_reviews": "Show {score}-star reviews",
            "show_translation": "Show translation",
            "title": "Customer reviews",
            "about": "About:",
            "read_more": "Read more",
            "show_all": "Show all {count}",
            "votes_count": "1 rating | {count} ratings"
        },
        "shipping_options": {
            "title": "Delivery options"
        },
        "show_more_products": "Show more products",
        "stock": {
            "available": "Available directly from stock"
        },
        "checkout": {
            "title": "Checkout"
        },
        "filter_amount_products": "Filter {count} products",
        "pickup_points": {
            "pickup_location": {
                "confirmed": "Pickup point selected!",
                "select": "Pick up here"
            }
        },
        "price_table": {
            "filters": {
                "show_less": "Show fewer sizes",
                "show_more": "Show more sizes"
            }
        },
        "show_less_collections": "Show fewer collections",
        "show_more_collections": "Show more collections",
        "show_more": "Show more",
        "show_less": "Show less",
        "product_details": "Product information"
    },
    "pages": {
        "cart_page": {
            "add_product": "Add another product",
            "cart_item": {
                "delete": "Remove",
                "edit": "Edit",
                "edit_failed": "The product could not be opened for editing. Please try again.",
                "quantity": {
                    "label": "Quantity"
                },
                "set_count": "{count} product | {count} products",
                "show_details": "Show details"
            },
            "coupon_applied": "Discount code applied.",
            "coupon_apply_failed": "Discount code could not be applied.",
            "free_shipping_remaining": "{amount} more for {free}",
            "free_shipping_goal": "free delivery",
            "free_shipping_exception": "Excluding XXL parcels",
            "messages": {
                "success": {
                    "deleted": "The product has been removed from your cart."
                }
            },
            "no_items": "Your shopping cart is empty.",
            "no_items_proceed_shopping": "Click {link} to continue shopping.",
            "no_items_proceed_shopping_link": "here",
            "overview": {
                "coupon_code": {
                    "button": {
                        "label": "Apply"
                    },
                    "cancel": "Cancel",
                    "input": {
                        "placeholder": "Enter your discount code"
                    },
                    "title": "Enter discount code"
                },
                "coupon_code_display": "Discount code ({code})",
                "coupon_codes_display": "Discount codes",
                "discount_display": "Discount",
                "item_count": "1 item | {count} items",
                "prices": {
                    "discount": "You save",
                    "grand_total": "Total",
                    "shipping": "Shipping",
                    "subtotal": "Subtotal",
                    "tax": "VAT",
                    "tax_included": "incl. {amount} VAT",
                    "total_incl_tax": "Total (incl. VAT)"
                }
            },
            "overview_title": "Overview",
            "pages_count": "{count} pages",
            "proceed_to_checkout": "Place my order",
            "quantity_update_failed": "Quantity could not be updated.",
            "remove_modal": {
                "cancel": "Cancel",
                "confirm": "Are you sure you want to remove this product from your cart?",
                "set_confirm": "If you remove this product, the set discount on the remaining products no longer applies. Are you sure you want to remove it?",
                "title": "Remove product",
                "yes": "Yes, remove"
            },
            "title": "Shopping cart",
            "free_shipping": "Free shipping",
            "free_shipping_reached": "{free} on your order",
            "checkout_hint": "Next: choose your address and delivery time"
        },
        "category": {
            "filters_title": "Filters",
            "clear_all": "Clear all",
            "selected_count": "{count} selected",
            "selected_filters": "Selected filters",
            "hierarchy_all": "All {label}",
            "close_filters": "Close filters",
            "no_filter_options_available": "No filter options available",
            "no_image": "No image",
            "open_grid_view": "Open grid view",
            "open_list_view": "Open list view",
            "open_two_column_view": "Open 2-column view",
            "products": {
                "label": "products",
                "prices": {
                    "recommended_price": "instead of"
                }
            },
            "remove_filter": "Remove filter {filter}: {value}",
            "show_results": "Show results",
            "show_results_with_count": "Show {count} results",
            "clear_filters": "Remove all filters",
            "filter": "Filter",
            "show_less_filters": "Show less",
            "show_more_filters": "Show more",
            "faqs": {
                "title": "Frequently asked questions"
            },
            "header": {
                "header_description": {
                    "show_more": "More",
                    "show_less": "Less"
                }
            },
            "filter_explanation": "More information about this filter"
        },
        "collection": {
            "delivery_options": {
                "pickup_point": "Pickup point (sustainable choice)"
            }
        },
        "customers": {
            "dashboard": {
                "account_information": {
                    "form": {
                        "assistance_allowed_label": "Allow remote assistance while shopping",
                        "assistance_allowed_tooltip": "This allows employees to view your session and perform actions on your behalf to help you while shopping.",
                        "email_label": "Email address",
                        "first_name_label": "First Name",
                        "last_name_label": "Last Name",
                        "legend": "Account Information",
                        "submit_button": "Save"
                    },
                    "index": {
                        "intro": "My contact details and account settings.",
                        "title": "Account Information"
                    }
                },
                "address": {
                    "billing_title": "Default Billing Address",
                    "description": "Current default billing and shipping address.",
                    "legend": "Address Book",
                    "manage_link": "Manage addresses",
                    "shipping_title": "Default Shipping Address"
                },
                "addresses": {
                    "create": {
                        "intro": "Add a new address to the address book.",
                        "title": "New Address"
                    },
                    "default_cards": {
                        "empty_state": "No default address has been set yet."
                    },
                    "edit": {
                        "intro": "Edit an existing address from the address book.",
                        "title": "Edit Address"
                    },
                    "form": {
                        "address_legend": "Address",
                        "city_label": "City",
                        "company_label": "Company",
                        "contact_legend": "Contact Information",
                        "countries": {
                            "AT": "Austria",
                            "BE": "Belgium",
                            "DE": "Germany",
                            "FR": "France",
                            "LU": "Luxembourg",
                            "NL": "Netherlands"
                        },
                        "country_label": "Country",
                        "default_billing_label": "Use as default billing address",
                        "default_shipping_label": "Use as default shipping address",
                        "first_name_label": "First Name",
                        "last_name_label": "Last Name",
                        "postcode_label": "Postal Code",
                        "region_label": "State/Province",
                        "street1_label": "Address",
                        "street2_label": "Address Line 2",
                        "submit_create_button": "Add Address",
                        "submit_edit_button": "Save Address",
                        "telephone_label": "Phone Number"
                    },
                    "index": {
                        "add_address_button": "Add Address",
                        "billing_action_text": "Change billing address",
                        "billing_title": "Default Billing Address",
                        "delete_modal_cancel_button": "Cancel",
                        "delete_modal_confirm_button": "Delete",
                        "delete_modal_description": "Are you sure you want to delete this address?",
                        "delete_modal_title": "Delete Address",
                        "intro": "My addresses and additional details.",
                        "shipping_action_text": "Change shipping address",
                        "shipping_title": "Default Shipping Address",
                        "title": "Address Book"
                    },
                    "list": {
                        "address_column": "Address",
                        "city_column": "City",
                        "company_column": "Company",
                        "country_column": "Country",
                        "delete_label": "Delete",
                        "edit_title": "Edit",
                        "empty_state": "No additional addresses have been added yet.",
                        "legend": "Additional Addresses",
                        "name_column": "Name"
                    }
                },
                "empty_address_state": "No address has been set yet.",
                "intro": "Welcome {firstName}! Below you will find all your information and recent orders.",
                "navigation": {
                    "account_information": "Account Information",
                    "address_book": "Address Book",
                    "dashboard": "Dashboard",
                    "logout": "Sign Out",
                    "orders": "My Orders",
                    "projects": "My Photo Books",
                    "security": "Security",
                    "title": "My Account",
                    "wishlist": "Wishlist"
                },
                "order_history": {
                    "detail": {
                        "header": {
                            "date_label": "Date"
                        },
                        "index": {
                            "back_button": "Back to order overview",
                            "intro": "Detailed overview of an order.",
                            "title": "Order # {number}"
                        },
                        "info": {
                            "billing_address_title": "Billing Address",
                            "payment_method_title": "Payment Method",
                            "shipping_address_title": "Shipping Address",
                            "shipping_method_title": "Shipping Method"
                        },
                        "items": {
                            "article_number_label": "SKU",
                            "legend": "Ordered Items",
                            "price_column": "Price",
                            "product_name_column": "Product Name",
                            "quantity_column": "Quantity",
                            "subtotal_column": "Subtotal"
                        },
                        "totals": {
                            "discount": "Discount",
                            "grand_total": "Grand Total (Incl. Tax)",
                            "grand_total_excluding_tax": "Grand Total (Excl. Tax)",
                            "shipping": "Shipping and Handling",
                            "subtotal": "Subtotal",
                            "tax": "Tax"
                        }
                    },
                    "index": {
                        "intro": "Overview of my placed orders.",
                        "legend": "My Orders",
                        "order_count": "{count} order | {count} orders",
                        "title": "My Orders"
                    },
                    "table": {
                        "date_column": "Date",
                        "empty_state": "You have not placed any orders yet.",
                        "order_number_column": "Order no.",
                        "status_column": "Status",
                        "total_column": "Total",
                        "tracking_column": "Track & trace",
                        "view_label": "View"
                    }
                },
                "orders": {
                    "date_column": "Date",
                    "empty_state": "You have not placed any orders yet.",
                    "legend": "Recent Orders",
                    "order_number_column": "Order no.",
                    "shipping_to_column": "Ship to",
                    "status_column": "Status",
                    "total_column": "Total",
                    "view_all_link": "View all",
                    "view_link": "View"
                },
                "profile": {
                    "create": {
                        "intro": "Add a new address to the address book.",
                        "title": "New Address"
                    },
                    "edit": {
                        "intro": "Edit an existing address from the address book.",
                        "title": "Edit Address"
                    },
                    "edit_link": "Edit or change password",
                    "form": {
                        "address_legend": "Address",
                        "city_label": "City",
                        "company_label": "Company",
                        "contact_legend": "Contact Information",
                        "country_label": "Country",
                        "default_billing_label": "Use as default billing address",
                        "default_shipping_label": "Use as default shipping address",
                        "first_name_label": "First Name",
                        "last_name_label": "Last Name",
                        "postcode_label": "Postal Code",
                        "region_label": "State/Province",
                        "street1_label": "Address",
                        "street2_label": "Address Line 2",
                        "submit_create_button": "Add Address",
                        "submit_edit_button": "Save Address",
                        "telephone_label": "Phone Number"
                    },
                    "legend": "Contact Information",
                    "list": {
                        "address_column": "Address",
                        "city_column": "City",
                        "company_column": "Company",
                        "country_column": "Country",
                        "delete_label": "Delete",
                        "edit_title": "Edit",
                        "empty_state": "No additional addresses have been added yet.",
                        "legend": "Additional Addresses",
                        "name_column": "Name"
                    }
                },
                "projects": {
                    "index": {
                        "intro": "My saved projects and photo books.",
                        "legend": "My Photo Books",
                        "title": "My Photo Books"
                    },
                    "list": {
                        "actions_column": "Actions",
                        "empty_state": "You have not saved any photo books yet.",
                        "fallback_text": "Photo book preview",
                        "preview_alt": "Preview",
                        "preview_link": "Preview",
                        "product_column": "Product",
                        "project_link": "Go to project",
                        "updated_at_column": "Last updated"
                    }
                },
                "security": {
                    "form": {
                        "legend": "Change Password",
                        "submit": "Save Password"
                    },
                    "index": {
                        "intro": "Update your account password here.",
                        "title": "Security"
                    }
                },
                "title": "My Account",
                "wishlist": {
                    "index": {
                        "empty_state": "Your wishlist is empty.",
                        "intro": "Products you have saved.",
                        "legend": "My wishlist",
                        "title": "Wishlist",
                        "guest_notice": "Saved on this device · {login} to see your items everywhere",
                        "guest_notice_login": "Log in"
                    },
                    "share": {
                        "button": "Share",
                        "title": "Share your wishlist",
                        "description": "Anyone with this link can view your wishlist.",
                        "copy": "Copy link",
                        "share_via": "Share via…",
                        "copied": "Link copied",
                        "email": "Email"
                    },
                    "shared": {
                        "title": "Shared wishlist",
                        "intro": "These products were shared with you."
                    }
                },
                "intro_no_name": "Welcome! Below you will find all your information and recent orders."
            },
            "login": {
                "index": {
                    "create_account": "Create an Account",
                    "description": "If you have an account, sign in with your email address.",
                    "email_label": "Email address",
                    "email_placeholder": "name{'@'}example.com",
                    "forgot_password": "Forgot Your Password?",
                    "intro": "Sign in or create an account to go to your dashboard.",
                    "legend": "Sign In",
                    "new_customers_description": "Creating an account has many benefits: check out faster, keep more than one address, track orders and more.",
                    "new_customers_legend": "New Customers",
                    "password_label": "Password",
                    "password_placeholder": "Enter your password",
                    "submit": "Sign In",
                    "title": "Sign In",
                    "sso_facebook": "Continue with Facebook",
                    "sso_google": "Continue with Google",
                    "sso_separator": "Or"
                }
            },
            "passwords": {
                "forgot": {
                    "index": {
                        "back_button": "Back to sign in",
                        "description": "If an account exists with the provided email address, you will receive an email.",
                        "email_label": "Email address",
                        "email_placeholder": "name{'@'}example.com",
                        "intro": "Enter your email address below to receive a password reset link.",
                        "submit_button": "Send",
                        "title": "Forgot Your Password?"
                    }
                },
                "reset": {
                    "index": {
                        "intro": "Choose a new password for your account below.",
                        "submit": "Set a New Password",
                        "title": "Set a New Password"
                    }
                }
            },
            "register": {
                "credentials": {
                    "email_label": "Email address",
                    "legend": "Sign-in Information",
                    "privacy_link": "Privacy Policy",
                    "privacy_prefix": "I agree to the"
                },
                "index": {
                    "back_button": "Back to sign in",
                    "intro": "Create a new account to manage your orders, addresses and projects.",
                    "submit_button": "Create an Account",
                    "title": "Create a New Account"
                },
                "profile": {
                    "first_name_label": "First Name",
                    "last_name_label": "Last Name",
                    "legend": "Personal Information",
                    "subscribe_label": "Sign up for the newsletter"
                }
            }
        },
        "errors": {
            "back_to_home": "Back to homepage",
            "404": {
                "heading": "Page not found.",
                "description": "We couldn't find the page you were looking for. The link may have expired or the page may have been moved."
            },
            "500": {
                "heading": "Something went wrong.",
                "description": "An unexpected error occurred on our end. Please try again later."
            },
            "403": {
                "heading": "Access denied.",
                "description": "You don't have permission to view this page."
            },
            "503": {
                "heading": "Temporarily unavailable.",
                "description": "The website is temporarily unavailable. Please try again later."
            },
            "generic": {
                "heading": "An error occurred.",
                "description": "An unexpected error occurred. Please try again later."
            }
        },
        "product_detail_page": {
            "share": {
                "label": "Share this page",
                "copied": "Link copied"
            },
            "product_info": {
                "benefits": {
                    "title": "The benefits of {storeName}",
                    "payment_methods_label": "pay with, among others"
                },
                "klarna": {
                    "loading": {
                        "label": "Klarna is loading..."
                    }
                },
                "modals": {
                    "product_options_modal": {
                        "overview": {
                            "title": "Overview"
                        },
                        "title": "Product options"
                    }
                },
                "product_button": {
                    "add_to_cart": {
                        "error": "Something went wrong while adding to your cart.",
                        "loading": {
                            "description": "You'll be redirected automatically.",
                            "label": "Adding to cart..."
                        },
                        "set_error": "Something went wrong while adding the set. Some parts may already be in your cart, so check your cart before trying again."
                    },
                    "book_login_modal": {
                        "continue_without_login": "Continue without logging in",
                        "continue_without_login_warning": "If you continue without logging in, your photos will not be saved. You will not be able to edit or complete your product later.",
                        "description": "Log in to save your progress and continue your project later.",
                        "email_label": "Email address",
                        "email_placeholder": "name{'@'}example.co.uk",
                        "forgot_password": "Forgot password?",
                        "general_error": "Login failed. Check your details and try again.",
                        "no_account": "No account yet?",
                        "password_label": "Password",
                        "password_placeholder": "Enter your password",
                        "separator": "Or",
                        "submit": "Log in",
                        "title": "Log in"
                    },
                    "new_project_modal": {
                        "description": "Give your photo book a title so you can find it back easily. You can always change it later.",
                        "submit": "Start creating",
                        "title": "Name your project",
                        "title_hint": "{count} / 150",
                        "title_label": "Project title",
                        "title_placeholder": "E.g. Holiday {year}, Family Album..."
                    },
                    "recent_projects_modal": {
                        "description": "Continue with an existing photobook project or start a new project.",
                        "empty_state": "You do not have any recent photobook projects yet.",
                        "error": "Something went wrong while loading your projects.",
                        "loading": "Loading your recent projects...",
                        "next_page": "Next",
                        "open_error": "The project could not be opened. Please try again.",
                        "open_project": "Open project",
                        "opening": "Opening...",
                        "pagination": "Page {page} of {total}",
                        "previous_page": "Previous",
                        "retry": "Try again",
                        "sheet_count": "{count} pages",
                        "start_new_project": "Start new project",
                        "title": "Recent projects",
                        "updated_at": "Last edited: {date}"
                    },
                    "start_ordering": {
                        "loading": {
                            "description": "We're getting the designer ready for you.",
                            "label": "Preparing your design..."
                        }
                    },
                    "start_over": {
                        "confirm_modal": {
                            "cancel": "Cancel",
                            "confirm": "Yes, start over",
                            "description": "Your current photo and settings will be removed. This cannot be undone.",
                            "title": "Are you sure you want to start over?"
                        },
                        "label": "Or start over, choose a new photo"
                    },
                    "upload": {
                        "errors": {
                            "file_too_large": "This photo is too large. Please upload an image of up to 100 MB.",
                            "generic": "Something went wrong while uploading. Please try again.",
                            "invalid_file_type": "This file type is not supported. Please upload a JPG, PNG or WebP image.",
                            "retry_cta": "Try again",
                            "title": "Upload failed"
                        },
                        "leave_modal": {
                            "cancel": "Stay here",
                            "confirm": "Stop upload",
                            "description": "Your photo is still uploading. If you leave now, your progress will be lost.",
                            "title": "Are you sure you want to leave?"
                        },
                        "offline": {
                            "description": "You're offline. We'll pick up where we left off as soon as you're back online.",
                            "title": "No connection"
                        },
                        "redirecting": {
                            "description": "You're being redirected.",
                            "label": "Upload complete!"
                        },
                        "uploading": {
                            "description": "You'll be redirected automatically.",
                            "label": "Your photo is being processed..."
                        }
                    },
                    "update_cart": {
                        "loading": {
                            "description": "You'll be redirected to your cart automatically.",
                            "label": "Your product is being updated."
                        }
                    },
                    "force_size_selection_message": "Please select a size before continuing.",
                    "force_size_selection_tooltip": "You still need to select a size"
                },
                "product_filters": {
                    "choose_option": "Choose an option",
                    "make_your_choice": "Make your choice"
                },
                "product_set": {
                    "available_sizes_label": "Choose your sizes",
                    "discount_label": "Set discount",
                    "position_label": "Image {number}",
                    "save_label": "Save",
                    "standard_sizes_note": "Images are based on standard sizes"
                },
                "switch_options": {
                    "with_name": "With name",
                    "without_name": "Without name"
                }
            },
            "user_text": {
                "error": {
                    "empty": "No text filled in"
                },
                "label": "Personal text",
                "placeholder": "Enter your text..."
            },
            "price": {
                "from_abbreviation": "from",
                "instead_of": "instead of"
            },
            "after_upload_text": "Then: choose size & view prices",
            "timer": {
                "label": "{days} days and {hours}:{minutes}:{seconds}",
                "last_day_label": "Only {hours} hours and {minutes}:{seconds} left",
                "one_day_label": "{days} day and {hours}:{minutes}:{seconds}"
            },
            "ai_upload": {
                "history": {
                    "loading_previous": "Loading your previous version",
                    "loading_latest": "Loading your latest version"
                },
                "auth": {
                    "email": {
                        "continue": "Continue",
                        "context": "Enter your email address to upload your own photo and have it generated with AI.",
                        "error": "Something went wrong. Please try again.",
                        "placeholder": "Your email address",
                        "title": "Continue"
                    },
                    "login": {
                        "context": "An account already exists for {email}. Log in to continue.",
                        "forgot_password": "Forgot password?",
                        "general_error": "Login failed. Check your details and try again.",
                        "password_placeholder": "Enter your password",
                        "submit": "Log in",
                        "title": "Log in"
                    },
                    "otp": {
                        "general_error": "Something went wrong. Please try again.",
                        "intro": "We've sent a verification code to {email}.",
                        "resend": "Didn't get a code? Resend",
                        "resend_sent": "We've sent you a new code.",
                        "submit": "Confirm and choose photo",
                        "title": "Confirm your email",
                        "submit_continue": "Confirm"
                    },
                    "success": {
                        "title": "Logged in!",
                        "cta": "Select your photo"
                    }
                },
                "ai_generated_badge": "AI generated",
                "view_full_screen": "View the photo full screen",
                "button": {
                    "label": "Start your order",
                    "choose_photo": "Choose your photo",
                    "try_again": "Try again",
                    "offline": "You're offline. The upload will continue automatically once your connection is restored.",
                    "slow_connection": "You have a slow connection. The upload may take a little longer.",
                    "add_text": "Add name/text",
                    "edit_text": "Edit name/text",
                    "errors": {
                        "invalid_file_type": "This file type isn't supported. Please upload a photo in JPG, PNG or WEBP format.",
                        "file_too_small": "This file is too small. Please choose a different photo.",
                        "file_too_large": "This file is too large. Please upload a photo of 100 MB or less."
                    }
                },
                "progress": {
                    "retry": "Try again",
                    "retry_different_photo": "Upload a different photo",
                    "beauty_shots_failed": "Unfortunately, we couldn't create your product previews. Please try again.",
                    "image_failed": "This product image could not be created.",
                    "overtime": "This is taking a bit longer than expected. We’re still working on it, please hold on.",
                    "shot_pending": "This product photo is still being made. The others are ready to look at.",
                    "creating_previews": "We're now creating your product previews...",
                    "title": "Your image is being created",
                    "subtitle": "On average 60-90 seconds. Thanks for your patience.",
                    "baking_title": "We're making new product images for you",
                    "bake_progress_title": "New product images are loading",
                    "bake_progress_subtitle": "New product images are being created based on your name.",
                    "preparing_photo_error": "We couldn't prepare your product photo. Please try again.",
                    "preparing_photo_and_cart_title": "Adding your product to your cart",
                    "preparing_photo_and_cart_description": "We're finishing your personalised product photo at the same time.",
                    "beauty_shots_count": "{completed} of {total}",
                    "steps": {
                        "analyzing": "Analysing photo",
                        "recognizing": "Recognising face",
                        "styling": "Applying style",
                        "finalizing": "Finalising design",
                        "creating_images": "Creating images",
                        "uploading": "Processing your photo",
                        "generating": "Creating your image",
                        "processing": "Finishing your image",
                        "processing_plural": "Finishing your images",
                        "previews": "Creating product images",
                        "preview_single": "Creating your product image",
                        "preview_plural": "Creating your product images",
                        "uploading_busy": "This is taking a little longer than expected...",
                        "analyzing_busy": "Taking a careful look...",
                        "generating_busy": "Your image is being made...",
                        "generating_busy_plural": "Your images are being made...",
                        "processing_busy": "Finishing touches...",
                        "previews_busy": "Your product images are being created, just a moment...",
                        "baking_text": "Baking in text...",
                        "baking_style": "Applying text & style",
                        "baking_text_subtitle": "Your text is being applied to the image.",
                        "baking_photo": "Updating product image",
                        "addition_activating": "Loading {label} style",
                        "addition_transforming": "Transforming preview",
                        "addition_transforming_subtitle": "We're transforming your image",
                        "addition_generating": "Generating {label}",
                        "addition_finalizing": "Finishing details",
                        "uploading_subtitle": "Getting your photo ready for the AI",
                        "analyzing_subtitle": "Working out what's in your photo",
                        "generating_subtitle": "The AI is creating your image",
                        "generating_subtitle_plural": "The AI is creating your images",
                        "processing_subtitle": "Adding the finishing touches",
                        "addition_activating_subtitle": "Loading the style you picked",
                        "uploading_done": "Photo processed",
                        "analyzing_done": "Photo analysed",
                        "generating_done": "Image created",
                        "generating_done_plural": "Images created",
                        "processing_done": "Details finished",
                        "addition_activating_done": "Style loaded",
                        "addition_transforming_done": "Preview ready"
                    }
                },
                "regenerate": {
                    "title": "Generate again",
                    "feedback_placeholder": "\"More realistic\" or \"More vivid colours\"",
                    "with_feedback": "With feedback",
                    "error_generic": "Something went wrong. Please try again.",
                    "threshold_exceeded": "The daily AI photo generation limit has been reached. Please try again tomorrow.",
                    "style_additions_generate": "Preview with {label}",
                    "style_additions_cost_notice": "You are using 1 AI credit",
                    "style_additions_title": "Choose an addition"
                },
                "crop": {
                    "panel_title": "Select your face",
                    "panel_description": "Use the selection box to frame your face. This gives you the best result.",
                    "image_load_error": "We couldn't load your photo. Please try a different image.",
                    "zoom_in": "Zoom in",
                    "zoom_out": "Zoom out",
                    "validating": "Checking photo…",
                    "error_title": "That did not work"
                },
                "validation": {
                    "retry": "Choose a different photo",
                    "cancel": "Cancel",
                    "no_face": {
                        "title": "Face not recognised",
                        "description": "We could not recognise a clear face in your selection. Move the selection over the face, or upload a different photo.",
                        "tip_1": "Look straight into the camera.",
                        "tip_2": "Ensure good lighting — avoid backlighting.",
                        "tip_3": "Remove sunglasses, masks, or caps."
                    },
                    "no_pet": {
                        "title": "No pet detected",
                        "description": "We couldn't detect a pet in your photo. Please upload a photo where your pet is clearly visible."
                    },
                    "mismatch": {
                        "title": "No person detected",
                        "description": "We could not recognise a person in your selection. Move the selection over the face, or upload a different photo.",
                        "tip_1": "Move the selection so the face sits inside the frame.",
                        "tip_2": "Or upload a photo where the person is clearly visible."
                    },
                    "unsafe": {
                        "title": "Photo not accepted",
                        "description": "Your photo doesn't meet our guidelines. Please upload a different photo.",
                        "tip_1": "Use a suitable, neutral portrait photo."
                    },
                    "unavailable": {
                        "title": "Photo check unavailable",
                        "description": "The photo check is temporarily unavailable. Your photo has been submitted as-is.",
                        "tip_1": "Try again later if you experience any issues."
                    }
                },
                "daily_limit_reached": "AI photo generation is temporarily unavailable. Please try again tomorrow.",
                "user_daily_limit_reached": "You have reached your AI generation limit. Please try again in 1 hour. | You have reached your AI generation limit. Please try again in {count} hours.",
                "related_styles": {
                    "title": "AI styles"
                },
                "view_previous_generations": "View previous generations",
                "transfer": {
                    "title": "Re-use your previous photo",
                    "dismiss": "Use a different photo",
                    "generate": "Generate now",
                    "photo_label": "Your photo",
                    "change": "Change photo"
                },
                "beauty_shots_generating": "{count} product photo still generating... | {count} product photos still generating...",
                "personalization": {
                    "alignment_label": "Alignment",
                    "weight_label": "Weight",
                    "reset_text": "Reset text",
                    "remove_text": "Remove text",
                    "remove_all_text": "Start over",
                    "weight_300": "Thin",
                    "weight_400": "Normal",
                    "weight_500": "Medium",
                    "weight_600": "Semi-bold",
                    "weight_700": "Bold",
                    "weight_800": "Extra bold",
                    "weight_900": "Black",
                    "uncommitted_modal_title": "Text not yet generated",
                    "uncommitted_modal_body": "You have added text, but it has not been generated onto the photo yet.",
                    "uncommitted_add_without_text": "Order without text",
                    "uncommitted_generate": "Generate and verify",
                    "uncommitted_cancel": "Continue personalizing",
                    "uncommitted_generate_and_add": "Generate & continue",
                    "uncommitted_next_product_options": "You will then choose your product options.",
                    "uncommitted_next_redirect_to_cart": "You will then be redirected to your cart automatically.",
                    "active_banner": "Other photos locked",
                    "active_banner_tooltip": "You are in personalisation mode. Collapse the personalisation to view the other photos again, or generate a preview.",
                    "remove": "Remove text",
                    "drag_hint": "Drag to reposition",
                    "update_preview": "Save and preview",
                    "add_text": "Add text",
                    "generating": "Generating...",
                    "committed_hint": "Remove a text to return to the original preview.",
                    "background_padding_label": "Padding",
                    "color_label": "Text color",
                    "font_label": "Font",
                    "mode_text": "Text",
                    "preview_mode": "Preview mode – not yet generated",
                    "size_label": "Size",
                    "text_placeholder": "Your text here",
                    "title": "Add text",
                    "title_update": "Update personalisation",
                    "field_label": "Name/text",
                    "cta_add": "Add",
                    "cta_edit": "Edit",
                    "edit_baked_text": "Change text",
                    "edit_baked_notice": "Your text is part of the image now. Change it and we’ll redo the photos with your new text.",
                    "view_photos": "View all photos",
                    "mobile_save": "Save",
                    "text_done": "Save text"
                },
                "cycle_limit_go_back": "← View previous results",
                "cycle_limit_reached_with_previous_title": "You have used all your attempts",
                "user_limit_reached_unknown_wait": "You have reached your AI generation limit. Please try again later.",
                "status": {
                    "loading": {
                        "label": "Your photo is uploading",
                        "description": "We will take you onward automatically."
                    },
                    "offline": {
                        "title": "No connection",
                        "description": "You're offline. We'll pick up where we left off as soon as you're back online."
                    },
                    "errors": {
                        "title": "Upload failed",
                        "generic": "Something went wrong while uploading. Please try again.",
                        "retry_cta": "Try again"
                    }
                }
            }
        },
        "product_options": {
            "preview_alt": "Preview",
            "saved_price": "You save {amount}",
            "title": "Overview of your product",
            "preview_loading": "Loading preview...",
            "update_cart": "Update cart"
        },
        "tools": {
            "add_to_cart_error": {
                "description": "We couldn't add your product to the cart. Don't worry — your configuration is saved.",
                "retry": "Try again",
                "title": "Something went wrong"
            },
            "ai": {
                "crop": {
                    "title": "Crop",
                    "sidebar": "Crop tools"
                },
                "select": {
                    "title": "Choose",
                    "heading": "Choose your favourite",
                    "description": "Pick the one you like best.",
                    "candidate_label": "Variant {number}",
                    "name_placeholder": "Your name",
                    "candidate_pending": "This variant is still being made…",
                    "candidate_failed": "This variant could not be made.",
                    "candidate_retry": "Try again",
                    "candidate_selected": "Selected",
                    "select_candidate": "Select variant {number}",
                    "view_larger": "View variant {number} larger",
                    "choose_this": "Choose this one",
                    "show_all": "Show all my images",
                    "limit_reached": "You've reached your generation limit. Choose from the images you already have.",
                    "regenerate_question": "Not happy with these?",
                    "regenerate": "Make two new ones",
                    "regenerating": "Generating two more…",
                    "regenerate_error": "We could not generate more images. Please try again later.",
                    "save_error": "We could not save your choice. Please try again."
                },
                "configurator": {
                    "title": "Personalise",
                    "sidebar": "Text",
                    "panel_title": "Add your text",
                    "name_required_hint": "Enter your own name to continue.",
                    "view_preview_button": "View preview",
                    "preparing": {
                        "loading": {
                            "label": "Making your product image",
                            "description": "One moment…"
                        }
                    }
                },
                "preview": {
                    "title": "Preview",
                    "shot_pending": "This image is still being made…",
                    "shot_failed": "This image could not be made.",
                    "retry_shot": "Try again",
                    "go_to_shot": "Go to image {number}",
                    "previous_shot": "Previous image",
                    "next_shot": "Next image",
                    "view_larger": "View image {number} larger",
                    "filling": "Making images"
                }
            },
            "mediaclip": {
                "configurator": {
                    "choose_size": {
                        "label": "Choose your size"
                    },
                    "custom_size": {
                        "label": "Choose a custom size"
                    },
                    "title": "Configurator"
                }
            },
            "product_options": {
                "title": "Product options"
            }
        },
        "success_page": {
            "banner": {
                "title": "Done!",
                "sub_title": "Thank you for your order. We'll get started right away."
            },
            "title": "What happens next?",
            "steps": {
                "order_confirmation": {
                    "title": "Order confirmation",
                    "description": "We'll send you an order confirmation (<strong>#{orderNumber}</strong>) to your email address. Find all your orders in your account.",
                    "description_fallback": "We'll send you an order confirmation to your email address. Find all your orders in your account.",
                    "summary": {
                        "total_paid": "Total paid (incl. VAT)",
                        "total_in_email": "You will find the amount paid in your order confirmation.",
                        "show": "View your order",
                        "hide": "Hide your order",
                        "discount": "Discount",
                        "discount_code": "Discount code {code}",
                        "shipping": "Shipping",
                        "free": "Free",
                        "payment_fee": "Payment fee",
                        "other": "Other",
                        "total": "Total"
                    }
                },
                "shipping_confirmation": {
                    "title": "Shipping confirmation",
                    "description": "You'll receive an email once your products are packed and handed over to the courier.",
                    "delivery_date": "Estimated delivery"
                },
                "delivery_address": {
                    "title": "Delivery address",
                    "description": "Your item(s) will be delivered to",
                    "info": "Not home? Your parcel will be left with a neighbour or at a pickup point."
                },
                "questions": {
                    "title": "Questions?",
                    "description": "We're happy to help! Take a look at our",
                    "customer_service_link": "customer service page",
                    "show_the_wow": {
                        "title": "Show the WOW!",
                        "description": "Show your friends what you treated yourself to!",
                        "instagram_label": "Instagram",
                        "facebook_label": "Facebook"
                    },
                    "news_letter": {
                        "label": "Exclusive",
                        "title": "Become a WOW member?",
                        "usp_1": "10% off your next order",
                        "usp_2": "Discover new designs and products before anyone else",
                        "usp_3": "Exclusive discount codes & promotions",
                        "button": "Become a member"
                    }
                }
            },
            "page_title": "Order placed!"
        },
        "checkout_page": {
            "form": {
                "delivery": {
                    "available_from": "Available from",
                    "choose_pickup_location": "Choose your pickup point",
                    "day_after_tomorrow_delivery": "Order today, <b>delivered the day after tomorrow</b>!",
                    "deliver_at_pickup_location": "Select a pickup point",
                    "latest_delivery": "Your package will be delivered to your home at the latest on",
                    "no_address": "Enter your delivery address to see the available shipping methods.",
                    "no_pickup_locations": "No pickup points found",
                    "opening_times": {
                        "label": "Opening times"
                    },
                    "postal_code_search": {
                        "button": "Search",
                        "label": "Postal code",
                        "placeholder": "Enter a postal code"
                    },
                    "selected_pickup_location": "Selected pickup point:",
                    "show_on_map": "Show on map",
                    "show_other_pickup_locations": "Show more pickup points",
                    "tabs": {
                        "delivery": "Delivery",
                        "pickup": "Pickup point"
                    },
                    "tomorrow_delivery": "Order today, <b>delivered tomorrow</b>!",
                    "error": "Something went wrong loading delivery options."
                },
                "payment": {
                    "no_address": "Enter your delivery address to see the available payment methods.",
                    "no_payment_required": "No payment required.",
                    "no_payment_required_subtitle": "Your order is fully covered by your coupon code."
                }
            },
            "free": "Free",
            "messages": {
                "errors": {
                    "billing_address_missing": "Your billing address is incomplete. Please check your address and try again.",
                    "placing_order_failed": "Your order cannot be placed at the moment.",
                    "shipping_address_missing": "Your shipping address is incomplete. Please check your address and try again."
                }
            },
            "overview": {
                "place_order_button": {
                    "label": "Place order"
                },
                "prices": {
                    "discount": "Discount",
                    "shipping_costs": "Shipping costs",
                    "shipping_surcharge": "Surcharge",
                    "payment_fee": "Payment costs",
                    "subtotal": "Subtotal",
                    "total": "Total",
                    "you_save": "You save",
                    "coupon_code": "Discount code",
                    "incl_vat": "incl. {amount} VAT",
                    "promotion_discount": "Promotional discount"
                },
                "quote_items": {
                    "count": "1 item | {count} items",
                    "quantity": "Quantity: {quantity}"
                },
                "title": "Overview"
            },
            "payment": {
                "most_popular": "Most popular"
            }
        },
        "configurator": {
            "sizes": {
                "most_chosen": "Most chosen"
            }
        },
        "search": {
            "title": "Search results",
            "title_with_query": "Search results for ‘{query}’",
            "products_title": "Products",
            "heading_all": "All designs",
            "heading_with_query": "Search results for ‘{query}’",
            "heading_no_results": "No results for ‘{query}’",
            "subtitle_no_results": "Check your spelling or try a more general search term.",
            "browse_by_product_title": "Browse by product"
        }
    },
    "slices": {
        "algolia_slider": {
            "price": {
                "else": "otherwise",
                "from": "from"
            }
        },
        "plp_before_after": {
            "before": "Before",
            "after": "After"
        },
        "plp_customer_images": {
            "image_alt": "Customer photo"
        },
        "pdp_before_after": {
            "before": "Before",
            "after": "After"
        },
        "contact_form_business": {
            "gift_timing_placeholder": "When would you like to give the suitcases?*",
            "referral_placeholder": "How did you hear about us?*",
            "no_options": "No options available",
            "selected_file": "Selected file:",
            "required_fields": "Please fill in all required fields.",
            "submit_error": "Error submitting the form. Please try again.",
            "invalid_file_type": "Invalid file type. Only JPEG, PNG, GIF, BMP, WEBP or SVG are allowed."
        },
        "banner_slider": {
            "excellent": "Excellent"
        }
    },
    "tools": {
        "mediaclip": {
            "configurator": {
                "designer": {
                    "loading": "We're preparing your configurator."
                },
                "footer": {
                    "buttons": {
                        "cancel": {
                            "label": "Cancel"
                        },
                        "change_size": {
                            "label": "Change size ({size})"
                        },
                        "choose_size": {
                            "label": "Choose size"
                        },
                        "to_photo": {
                            "label": "To photo {number}"
                        }
                    }
                },
                "hexagon_photos_required_modal": {
                    "title": "Photos missing",
                    "description": "Photos {list} are still empty. Tap an empty frame, upload your photo and try again.",
                    "letter_collage_description": "Not every frame has a photo yet. Tap an empty frame, upload your photo and try again.",
                    "close": "Got it"
                },
                "connection_lost_modal": {
                    "title": "Connection lost",
                    "description": "We can't reach your design right now. Check your internet connection and reload the page; your design is saved automatically.",
                    "reload": "Reload page"
                },
                "project_title": {
                    "error": "Failed to save",
                    "label": "Project title",
                    "placeholder": "Enter a title...",
                    "saved": "Saved",
                    "saving": "Saving..."
                }
            }
        },
        "landscape_popup": {
            "text": "This page works better in portrait mode. Rotate the screen to continue with your order."
        }
    },
    "checkout": {
        "billing_address": {
            "title": "Billing address"
        },
        "delivery": {
            "preferences": {
                "label": "Which delivery do you prefer?",
                "express": {
                    "description": "Order today, delivered the day after tomorrow!",
                    "label": "Express delivery"
                },
                "regular": {
                    "label": "Regular delivery"
                }
            },
            "title": "Delivery",
            "delivery_date_info": "Your order will be delivered at the latest on ",
            "info": "Enter your shipping details to see the available delivery options"
        },
        "form": {
            "address_finder": {
                "invalid_address": "The entered address was not found. Please check your input and try again.",
                "label": "Address finder",
                "placeholder": "Start typing to search for your address",
                "address_filled": "Your address has been filled in.",
                "select_address": "Please select your address from the list."
            },
            "city": {
                "label": "City",
                "placeholder": "City",
                "invalid_characters": "Use only letters, spaces, hyphens (-) and apostrophes ('), up to 100 characters."
            },
            "company": {
                "label": "Company name",
                "placeholder": "Company name"
            },
            "country": {
                "label": "Country"
            },
            "email": {
                "label": "E-mail address",
                "placeholder": "E-mail address",
                "label_track_trace": "E-mail address for track & trace"
            },
            "first_name": {
                "label": "First name",
                "placeholder": "First name"
            },
            "house_number": {
                "label": "House number",
                "placeholder": "e.g. 1"
            },
            "house_number_suffix": {
                "label": "Suffix",
                "placeholder": "e.g. A"
            },
            "order_type": {
                "corporate": {
                    "label": "Corporate"
                },
                "private": {
                    "label": "Private"
                },
                "title": "Order type"
            },
            "phone_number": {
                "label": "Phone number",
                "placeholder": "Phone number",
                "invalid_characters": "Use only digits, spaces and + - ( ), up to 20 characters."
            },
            "same_address": {
                "label": "Billing and shipping address are the same"
            },
            "street_name": {
                "label": "Street name",
                "placeholder": "Street name"
            },
            "surname": {
                "label": "Surname",
                "placeholder": "Surname"
            },
            "vat_number": {
                "label": "VAT number",
                "placeholder": "VAT number"
            },
            "zipcode": {
                "label": "Zip code",
                "placeholder_example": "e.g. {example}",
                "invalid": "Enter a valid postcode, such as {example}."
            },
            "save_in_address_book": {
                "label": "Save in address book"
            },
            "newsletter_subscribe": {
                "label": "Keep me informed of news, inspiration and exclusive offers by email"
            },
            "account_type": {
                "title": "Account",
                "guest": {
                    "label": "Continue as guest"
                },
                "create": {
                    "label": "Create account"
                },
                "email_taken": "An account with this email address already exists.",
                "login_link": "Log in",
                "password_required": "Enter the same password twice to create your account.",
                "privacy_required": "You must accept the Privacy Policy to create your account."
            }
        },
        "payment": {
            "title": "Payment",
            "ideal_wero": {
                "description": "iDEAL {'|'} Wero"
            },
            "paypal": {
                "description": "Paypal"
            }
        },
        "shipping_address": {
            "title": "Shipping address"
        },
        "customer_addresses": {
            "add_new": "Add new address",
            "create_modal_title": "New address",
            "edit_modal_title": "Edit address",
            "delete_modal_title": "Delete address"
        },
        "address_book": {
            "add_new": "Add new address",
            "default_billing": "Default billing address",
            "default_shipping": "Default shipping address",
            "create_modal": {
                "title_shipping": "New shipping address",
                "title_billing": "New billing address",
                "confirm": "Save",
                "cancel": "Cancel"
            },
            "edit_modal": {
                "title": "Edit address",
                "confirm": "Save",
                "cancel": "Cancel"
            },
            "delete_modal": {
                "title": "Delete address",
                "confirm": "Delete",
                "cancel": "Cancel",
                "description": "Are you sure you want to delete this address? This cannot be undone."
            },
            "save_failed": "Saving failed. Please try again.",
            "delete_failed": "Deleting failed. Please try again.",
            "order_only": "Only for this order"
        }
    }
}
